import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import PersonIcon from '@mui/icons-material/Person';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import CookieIcon from '@mui/icons-material/Cookie';
import PolicyIcon from '@mui/icons-material/Policy';
import Alert from '@mui/material/Alert';
import { CookieBanner } from '../../pages/login/components/CookieBanner'; // Adjust path if needed

const footerItems = [
  {
    key: 'dev',
    icon: <PersonIcon sx={{ mr: 0.5, verticalAlign: 'middle' }} fontSize="small" />,
    text: 'Entwickler',
  },
  {
    key: 'mail',
    icon: <MailOutlineIcon sx={{ mr: 0.5, verticalAlign: 'middle' }} fontSize="small" />,
    text: (
      <Link href="mailto:ollo7776@gmail.com" color="inherit" underline="hover">
        Kontakt
      </Link>
    ),
  },
  {
    key: 'delete',
    icon: <DeleteIcon sx={{ mr: 0.5, verticalAlign: 'middle' }} fontSize="small" />,
    text: (
      <Link
        href="mailto:ollo7776@gmail.com?subject=Konto%20L%C3%B6schen%20Anfrage"
        color="inherit"
        underline="hover"
      >
        Konto löschen
      </Link>
    ),
  },
  {
    key: 'cookie',
    icon: <CookieIcon sx={{ mr: 0.5, verticalAlign: 'middle' }} fontSize="small" />,
    text: 'Cookies',
  },
  {
    key: 'policy',
    icon: <PolicyIcon sx={{ mr: 0.5, verticalAlign: 'middle' }} fontSize="small" />,
    text: (
      <Link
        href="https://daten.7776.link/"
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        underline="hover"
      >
        Datenschutzerklärung
      </Link>
    ),
  },
];

export default function Footer() {
  const [showDevInfo, setShowDevInfo] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [cookieConsent, setCookieConsent] = useState(null);

  const handleConsentChange = (consent) => {
    setCookieConsent(consent);
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
  };

  const handleOpenCookies = () => {
    setShowCookieBanner(true);
  };

  const handleCookieBannerClose = () => {
    setShowCookieBanner(false);
  };

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        px: 2,
        py: 1.5,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        fontSize: { xs: '0.9rem', sm: '1rem' },
        boxShadow: 2,
        position: 'relative',
      }}
    >
      {footerItems.map((item, idx) => (
        <React.Fragment key={item.key}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'pre-line',
              cursor: item.key === 'dev' || item.key === 'cookie' ? 'pointer' : 'default'
            }}
            onClick={
              item.key === 'dev'
                ? () => setShowDevInfo(true)
                : item.key === 'cookie'
                ? handleOpenCookies
                : undefined
            }
          >
            {item.icon}
            <Typography component="span" sx={{ fontSize: 'inherit' }}>
              {item.text}
            </Typography>
          </Box>
          {idx < footerItems.length - 1 && (
            <Divider orientation="vertical" flexItem sx={{ borderColor: 'primary.contrastText', mx: 1, display: { xs: 'none', sm: 'block' } }} />
          )}
        </React.Fragment>
      ))}
      <Box sx={{ width: '100%', mt: 1, textAlign: 'center', fontSize: '0.85em', opacity: 0.85 }}>
        Angebot von Programmierdienstleistungen sowie Entwicklung und Anpassung von Software für Unternehmen im ÖPNV. Ich lade zur Zusammenarbeit ein.
      </Box>
      {showDevInfo && (
        <>
          {/* Overlay to close popup on outside click */}
          <Box
            onClick={() => setShowDevInfo(false)}
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              zIndex: 1999,
              background: 'transparent',
            }}
          />
          <Box
            sx={{
              position: 'fixed',
              bottom: { xs: 70, sm: 30 },
              right: { xs: 10, sm: 30 },
              zIndex: 2000,
              minWidth: 320,
              maxWidth: 400,
            }}
          >
            <Alert
              severity="info"
              sx={{ width: '100%' }}
              onClose={() => setShowDevInfo(false)}
            >
              <strong>Entwickler:</strong> Aleksander Ligeza-Salamon<br />
              Angebot von Programmierdienstleistungen sowie Entwicklung und Anpassung von Software für Unternehmen im ÖPNV. 
              <br /><br />
              Ich lade zur Zusammenarbeit ein.
              <br /><br /><br />
              Die Anwendung wurde für Mitarbeiter der Deutschen Bahn in Frankfurt-Höchst entwickelt, um unsere Arbeit zu vereinfachen und die Qualität zu verbessern.<br />
              Wenn Sie Ideen oder Tipps haben, was noch nützlich sein könnte oder was geändert werden sollte, kontaktieren Sie mich bitte.
            </Alert>
          </Box>
        </>
      )}
      {showCookieBanner && (
        <CookieBanner
          open={showCookieBanner}
          onClose={handleCookieBannerClose}
          onConsentChange={handleConsentChange}
          forceShow={true}
        />
      )}
    </Box>
  );
}